import * as z from 'zod';

import { currencyInput, paginatedResponseSchema, percentageInput } from '@/_schemas/generic';

import { commissionEarningModelQuerySchema } from './commission-earning-model-schema';
import { commissionTiersQuerySchema } from './commission-tiers';

export const commissionPlansQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
  bonus_amount: currencyInput.querySchema(),
});

export type CommissionPlansQueryLinkerSchema = z.infer<typeof commissionPlansQueryLinkerSchema>;

export const commissionPlansQuerySchema = z.object({
  ...commissionPlansQueryLinkerSchema.shape,
  base_quota_amount: currencyInput.querySchema(),
  default_one_time_rate: percentageInput.querySchema(),
  default_recurring_rate: percentageInput.querySchema(),
  bonus_threshold: currencyInput.querySchema(),
  commission_tiers: z.array(commissionTiersQuerySchema),
  commission_earning_model: commissionEarningModelQuerySchema,
});

export type CommissionPlansQuerySchema = z.infer<typeof commissionPlansQuerySchema>;

export const commissionPlansQueryAllSchema = paginatedResponseSchema(commissionPlansQuerySchema);
export type CommissionPlansQueryAllSchema = z.infer<typeof commissionPlansQueryAllSchema>;
